var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"announcement"},[_vm._v("Please note that the loyalty shop is currently paused. We'll keep you updated.")])
}
var staticRenderFns = []

export { render, staticRenderFns }